import {
  Facts,
  Panel,
} from '@affdice/portal-kit';
import { t } from '../../messages.ts';

/**
 * Item 2 (third batch) — "somewhere to update my own profile", which did not
 * exist anywhere in this console. Read-only facts plus a voluntary entry
 * point into the same password flow §3.7's forced first-login already uses.
 */
export function Account({
  me,
  onChangePassword,
}: {
  me: { name: string | null; email: string };
  onChangePassword: () => void;
}) {
  return (
    <Panel title={t('plat.account.title')}>
      <Facts
        items={[
          { label: t('common.name'), value: me.name ?? '—' },
          { label: t('common.email'), value: me.email },
        ]}
      />
      <div className="form-actions">
        <button type="button" className="copy" onClick={onChangePassword}>
          {t('plat.account.changePassword')}
        </button>
      </div>
    </Panel>
  );
}
